import React from 'react';
import cx from 'classnames';
import ReactPaginate from 'react-paginate';
import { NextPage } from './components/NextPage';
import { PreviousPage } from './components/PreviousPage';
import styles from './style.module.css';

interface Props {
  totalPages?: number;
  onClick: any;
  forcePage: number;
  marginClass?: string;
}
export const Pagination = ({ totalPages, onClick, marginClass, forcePage = 0 }: Props) => {
  const hasMarginClass = cx({
    marginClass,
    'mt24 mt40-ns': !marginClass,
  });

  const containerClassName = cx(
    'list pa0 ma0 flex items-center justify-center w-100',
    hasMarginClass,
  );
  const subContainerClassName = cx(
    'pointer f18 fw6 bn pa0 flex boulder items-center hover-bg-alto br10 transition-ease',
    styles.space,
  );
  const activeClassName = cx('bg-red br10');

  return (
    <ReactPaginate
      forcePage={forcePage}
      previousLabel={<PreviousPage />}
      nextLabel={<NextPage />}
      breakLabel={'...'}
      breakClassName={'trueno boulder f18'}
      pageCount={totalPages}
      marginPagesDisplayed={2}
      pageRangeDisplayed={3}
      pageLinkClassName={'pv4 ph12'}
      onPageChange={onClick}
      containerClassName={containerClassName}
      pageClassName={subContainerClassName}
      activeLinkClassName="white"
      activeClassName={activeClassName}
    />
  );
};
